module.exports = __webpack_public_path__ + "img/Weilin Vision Metal Spring Inspection Software.cb12fce5.jpg";